module.exports = __webpack_public_path__ + "img/197484.c7ef7aee.png";